import clearValue from '../actions/clearValue'
import focusField from '../actions/focusField'
import validateCurrentField from '../actions/validateCurrentField'

export default [clearValue, focusField, validateCurrentField()]



// WEBPACK FOOTER //
// ./src/modules/client/chains/clearValue.js